<template>
  <v-theme-provider theme="localInsightLightTheme">
    <v-chip
      density="compact"
      class="py-1 pl-3 pr-2 mx-2 new-chip"
      prepend-icon="mdi-creation"
    >
      NEW
    </v-chip>
  </v-theme-provider>
</template>

<script>
export default {
  name: "NEWCHIP",
  data: () => ({}),
};
</script>

<style scoped>
.new-chip {
  background-color: rgb(var(--v-inverted-success));
  color: rgb(var(--v-on-inverted-success));
}
</style>
